var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.33398 21.6163V11.6497C3.33398 7.04967 7.06732 3.33301 11.6673 3.33301H28.334C32.934 3.33301 36.6673 7.04967 36.6673 11.6497V23.283C36.6673 27.8663 32.934 31.583 28.334 31.583H25.834C25.3173 31.583 24.8173 31.833 24.5007 32.2497L22.0007 35.5663C20.9007 37.033 19.1007 37.033 18.0007 35.5663L15.5007 32.2497C15.234 31.883 14.634 31.583 14.1673 31.583H11.6673C7.06732 31.583 3.33398 27.8663 3.33398 23.283V21.6163Z",
    fill: "#2C53F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 20.0003C19.0673 20.0003 18.334 19.2503 18.334 18.3337C18.334 17.417 19.084 16.667 20.0007 16.667C20.9173 16.667 21.6673 17.417 21.6673 18.3337C21.6673 19.2503 20.934 20.0003 20.0007 20.0003Z",
    fill: "#2C53F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 20.0003C25.7333 20.0003 25 19.2503 25 18.3337C25 17.417 25.75 16.667 26.6667 16.667C27.5833 16.667 28.3333 17.417 28.3333 18.3337C28.3333 19.2503 27.6 20.0003 26.6667 20.0003Z",
    fill: "#2C53F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 20.0003C12.3993 20.0003 11.666 19.2503 11.666 18.3337C11.666 17.417 12.416 16.667 13.3327 16.667C14.2493 16.667 14.9993 17.417 14.9993 18.3337C14.9993 19.2503 14.266 20.0003 13.3327 20.0003Z",
    fill: "#2C53F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.22ba9fe4b81d205c590d697b77241c80.svg";
export { ForwardRef as ReactComponent };